import BrowserLogger, * as browserRequestFunctions from './strategies/browser-strategy';
import ServerLogger, * as serverRequestFunctions from './strategies/server-strategy';

declare const __isBrowser__: boolean;

const Logger = __isBrowser__ ? BrowserLogger : ServerLogger;
const requestFunctions = __isBrowser__
    ? browserRequestFunctions
    : serverRequestFunctions;

export const requestLogger = requestFunctions.requestLogger;

export const errorRequestLogger = requestFunctions.errorRequestLogger;

export default Logger;
